import React, { useEffect, useRef, useState } from 'react';
import video from '../../assets/videos/demo.mp4';
import { motion } from 'framer-motion'
import { FaPlay, FaPause } from "react-icons/fa";
import { useLanguage } from '../../store/languageContext';
const VideoSection = () => {
    const videoRef = useRef(null);
    const cursorRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const sectionRef = useRef(null);
    const { setNavColor } = useLanguage();

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setNavColor('black');
                }
            },
            {
                threshold: 0.1,
                rootMargin: '-50px 0px -20% 0px',
            }
        );

        const currentRef = sectionRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [setNavColor]);
    const handleMouseEnter = () => {
        if (cursorRef.current) {
            cursorRef.current.style.display = 'flex';
        }
    };

    const handleMouseLeave = () => {
        if (cursorRef.current) {
            cursorRef.current.style.display = 'none';
        }
    };

    const handleMouseMove = (e) => {
        if (cursorRef.current) {
            cursorRef.current.style.left = `${e.clientX}px`;
            cursorRef.current.style.top = `${e.clientY}px`;
        }
    };

    const handleClick = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
                setIsPlaying(false);
            } else {
                videoRef.current.play();
                setIsPlaying(true);
            }
        }
    };

    return (
        <>
            <section
                className="landing-section container mx-auto flex justify-center items-center pb-[50px] relative h-[calc(100vh-100px)]"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onMouseMove={handleMouseMove}
                onClick={handleClick}
                ref={sectionRef}
            >
                <motion.video
                    initial={{ y: 100, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.3, delay: 0.2, ease: 'easeOut' }}
                    viewport={{ once: true }}
                    ref={videoRef}
                    muted
                    className="w-full h-full object-cover cursor-none rounded-[50px] shadow-lg"
                >
                    <source src={video} type="video/mp4" />
                    Your browser does not support the video tag.
                </motion.video>
            </section>
            <motion.div
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ duration: 0.5 }}
                ref={cursorRef}
                className="fixed pointer-events-none z-50 w-[60px] h-[60px] rounded-full bg-white/50 backdrop-blur-md flex items-center justify-center text-white text-sm border border-white font-semibold transform -translate-x-1/2 -translate-y-1/2"
            >
                {isPlaying ? <FaPause /> : <FaPlay />}
            </motion.div>
        </>
    );
};

export { VideoSection };